import UserService from "@/api/services/UserService"
import Vue from "vue"

const state = () => ({
    users: [],
    userRoles: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "username",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    USERS: state => {
        return state.users
    },
    USER_ROLES: state => {
        return state.userRoles
    },
    USERS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_USERS: (state, payload) => {
        state.users = payload
    },

    SET_USERS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_USER: (state, payload) => {
        state.users.push(payload)
    },

    UPDATE_USER: (state, payload) => {
        state.users = state.users.map(el => (el.id === payload.id ? payload : el))
    }
}

const actions = {
    LOAD_USERS: async ({ commit, state }, { filter, usuarioEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await UserService.get({ filter, usuarioEstado, ...pagination })
            if (status === 200) {
                let users = []
                data.forEach(user => {
                    user.statusEnabled = user.status === 10
                    users.push(user)
                })
                commit("SET_USERS", users)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los usuarios, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_USERS: async ({ commit }) => {
        try {
            let { data, status } = await UserService.getAll()
            if (status === 200) {
                commit("SET_USERS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_USERS: async ({ commit }) => {
        try {
            let { data, status } = await UserService.getAllRecords()
            if (status === 200) {
                commit("SET_USERS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los usuarios, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_USER: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.getHistory(payload)
            if (status === 200) {
                let user_details = data
                user_details.statusEnabled = user_details.status === 10
                commit("UPDATE_USER", user_details)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del usuario, inténtelo nuevamente"
            })
        }
    },

    ADD_USER: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.post(payload)
            if (status === 201) {
                let user_details = data
                user_details.statusEnabled = user_details.status === 10
                commit("ADD_USER", user_details)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El usuario ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el usuario, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_USER: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.put(payload)
            if (status === 200) {
                let user_details = data
                user_details.statusEnabled = user_details.status === 10
                commit("UPDATE_USER", user_details)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El usuario ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el usuario, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_USER_PASSWORD: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.put(payload)
            if (status === 200) {
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "La contraseña del usuario ha sido actualizada satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar la contraseña del usuario, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_USER: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.delete(payload)
            if (status === 200) {
                let user_details = data
                user_details.statusEnabled = user_details.status === 10
                commit("UPDATE_USER", user_details)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El usuario ha sido eliminado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar el usuario, inténtelo nuevamente"
            })
        }
    },

    TOOGLE_USER_STATUS: async ({ commit }, payload) => {
        try {
            let { data, status } = await UserService.toogleStatus(payload)
            if (status === 200) {
                let user_details = data
                user_details.statusEnabled = user_details.status === 10
                commit("UPDATE_USER", user_details)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El usuario ha sido habilitado/deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido modificar estado del usuario, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
